import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    borderBottom: 'none',
    padding: `${idsTokens.table.default.tableCell.padding.control.vertical} ${idsTokens.table.default.tableCell.padding.control.horizontal}`,
    position: 'relative',
    gap: idsTokens.table.default.tableCell.padding.control.gap,
    boxSizing: 'border-box',
    '&:first-of-type': {
      paddingLeft: `calc(${idsTokens.table.default.tableCell.padding.control.firstChild}*2)`,
    },
    '&:last-child': {
      paddingRight: `calc(${idsTokens.table.default.tableCell.padding.control.lastChild}*2)`,
    },
  },
  body: {
    fontSize: idsTokens.typography.font.size.sm,
    lineHeight: idsTokens.typography.lineHeight.sm,
    letterSpacing: idsTokens.typography.spacing.letter.md,
    fontWeight: idsTokens.typography.font.weight.regular,
    color: idsTokens.table.default.tableCell.color.text.label.enabled,
    minHeight: idsTokens.table.default.tableCell.minHeight,
  },
  head: {
    fontSize: 'inherit',
    color: idsTokens.table.default.tableCell.color.head.label.enabled,
    boxSizing: 'border-box',
    '&:not(class=*makeStyles-selectable)': {
      padding: `${idsTokens.table.default.tableCell.padding.head.vertical} ${idsTokens.table.default.tableCell.padding.head.horizontal}`,
    },
  },
});
